import { FunctionComponent } from 'react';
import { Button } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';

import {
  BeneficiaryForm,
  formatCompanyBeneficiaryToBeneficiaryFormInput,
} from '../../../../../../components/BeneficiaryForm';
import { BeneficiarySchema } from '../../../../../../components/BeneficiaryForm/beneficiarySchema';
import { GetBeneficiariesDataQuery } from '../../../../graphql/queries/getBeneficiariesData.gql';
import locales from './locales';

interface CreateBeneficiaryProps {
  isSending: boolean;
  data: GetBeneficiariesDataQuery['viewer'];
  onSubmit: (formValues: BeneficiarySchema) => void;
  onPrev: () => void;
}

const CreateBeneficiary: FunctionComponent<CreateBeneficiaryProps> = ({
  isSending,
  onPrev,
  onSubmit,
}) => {
  return (
    <>
      <Heading marginBottom="space-48" size="lg">
        {locales.title}
      </Heading>
      <BeneficiaryForm
        beneficiary={formatCompanyBeneficiaryToBeneficiaryFormInput(null)}
        primaryAction={{
          isSending,
          onSubmit,
          title: locales.cta,
        }}
        roleWarningCalloutContext="create"
        secondaryAction={
          <Button isDisabled={isSending} onClick={onPrev} variant="secondary">
            {locales.cancel}
          </Button>
        }
      />
    </>
  );
};

export default CreateBeneficiary;
